export enum IntakeFormSectionDataHook {
  ROOT = 'intake-form-section-root',
  FORM_CARD = 'intake-form-card',
  SECTION_CONTAINER = 'intake-form-section-container',
  SECTION_TITLE = 'intake-form-section-title',
  FORM_TITLE = 'intake-form-title',
  REQUIRED_BADGE = 'intake-form-required-badge',
  SECTION_SUBTITLE = 'intake-form-section-subtitle',
  CHEVRON_BUTTON = 'intake-form-chevron-button',
}
